var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ratingStars" },
    _vm._l(_vm.stars, function (star) {
      return _c(
        "span",
        {
          key: star,
          class: { rated: star <= _vm.value, unrated: star > _vm.value },
          on: {
            click: function ($event) {
              return _vm.rate(star)
            },
          },
        },
        [_c("i", { staticClass: "fas fa-star" })]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }